// extracted by mini-css-extract-plugin
export default {"faqRelated":"FaqRelated_faqRelated__7M1BM","title":"FaqRelated_title__5qNRB","faqList":"FaqRelated_faqList__w6sEX"};